import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import valuesService from "./valuesService";

const initialState = {
  dataValues: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// Get All values
export const valuesData = createAsyncThunk("valueData", async (thunkAPI) => {
  try {
    return await valuesService.valueData();
  } catch (err) {
    const message =
      (err.response && err.response.data && err.response.data.message) ||
      err.message ||
      err.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const valuesSlice = createSlice({
  name: "valueData",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(valuesData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(valuesData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dataValues = action.payload;
      })
      .addCase(valuesData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.dataValues = null;
      });
  },
});

export const { reset } = valuesSlice.actions;
export default valuesSlice.reducer;
